import { auth } from "./firebase";
import { signInWithEmailAndPassword, createUserWithEmailAndPassword, signOut, onAuthStateChanged, getAuth, updateProfile } from "firebase/auth";
import { async } from "@firebase/util";

 

function getResponseAndValidate(email, password) {
    const response = { error: "", user: null }

    if(email.length < 5) { 
        response.error = "Sähköpostiosoite puuttuu tai se on liian lyhty";
        return response;
    }

    if(password.length < 5) {
        response.error = "Salasana puuttuu tai se on liian lyhyt";
        return response;
    }

    return response;
}
async function signIn(email, password) {

    const response = getResponseAndValidate(email, password);

    if(response.error) return response;
    
    try {
        const res = await signInWithEmailAndPassword(auth, email, password);
        response.user = res.user;
    }
    catch(err) {
        response.error = err.message;
    }
    finally {
        return response;
    }
}

async function signUp(email, password) {

    const response = getResponseAndValidate(email, password);

    if(response.error) return response;
    
    try {
        const res = await createUserWithEmailAndPassword(auth, email, password);
        response.user = res.user;
    }
    catch(err) {
        response.error = err.message;
    }
    finally {
        return response;
    }
}

async function logOut() {
    const response = { error: "" }

    try {
        const res = await signOut(auth);
    }
    catch(err) {
        response.error = err.message;
    }
    finally {
        return response;
    }
}

function createAuthListener(callback) {
    return onAuthStateChanged(auth, user => callback(user));
}

async function updateUserProfile(data = {}) {
    const userAuth = getAuth();
    const user = userAuth.currentUser;

    const res = await updateProfile(user, data);
    return res;
}

export { signIn, signUp, logOut, createAuthListener, updateUserProfile }